import { CSSProperties } from "react"

export type FloatingPaletteLineList<T> =
  Record<string, { name: string; inputName: string & keyof T; inputType: string; }>;

export interface PaletteLinesProps<T> {
  argList: FloatingPaletteLineList<T>,
  currentInput: T,
  lineToEdit: keyof T
}
const PaletteLines = <T,>({ argList, currentInput, lineToEdit }: PaletteLinesProps<T>) => {

  return (<>
    {Object.values(argList)
      .map((inputAxis) =>
      (<PaletteLine
        key={inputAxis.name}
        name={inputAxis.name ?? ""}
        input={currentInput[inputAxis.inputName]?.toString() ?? ""}
        selectedLine={inputAxis.inputName === lineToEdit}
      />))}
  </>)
}

const PaletteLine = ({ name, input, selectedLine }: { name: string, input: string, selectedLine: boolean }) => {

  function selectEditign(): CSSProperties {
    return selectedLine ? { fontWeight: "bold" } : { fontWeight: "unset" }
  }

  return (
    <div>
      <span className="title">
        <span>{name}:</span>
      </span>
      <span style={selectEditign()}>{input}</span>
    </div>
  )
}
//(pointCoords.distance["x"].toFixed(0))
export default PaletteLines;